export enum KEY_PRESSED {
  ENTER = 13,
  ARROW_KEY_UP = 38,
  ARROW_KEY_DOWN = 40
}
